import ImageAvatar from './ImageAvatar';
import TextAvatar from './TextAvatar';
import CustomAvatar from './CustomAvatar';

export {ImageAvatar, TextAvatar, CustomAvatar};
